import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import { Typography } from '../typography';

import styles from './error.scss';

const COMPONENT_ID = 'modulor-error';

export type ErrorProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    error?: string;
    dataTestId?: string;
  };

export const Error: ForwardRefExoticComponent<ErrorProps> = forwardRef<HTMLDivElement, ErrorProps>(
  ({ error = '', dataTestId = COMPONENT_ID, className, ...rest }, ref) => {
    if (!error?.length) {
      return null;
    }

    return (
      <div
        className={classNames(className, styles.alert)}
        ref={ref}
        data-id={dataTestId}
        data-testid={dataTestId}
        data-component-name={COMPONENT_ID}
        {...rest}>
        <Typography variant="caption-1-regular">{error}</Typography>
      </div>
    );
  },
);

Error.displayName = 'Error';
